<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
/* 滚动条宽度 */
::-webkit-scrollbar {
 width: 6px;
 height: 5px;
}
::-webkit-scrollbar-thumb {
    background-color: rgba(157, 165, 183, 0.4);
    border-width: 1.5px;
    background-clip: padding-box;
    border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
    background-color: #A1A3A9;
}
</style>
